import { render, staticRenderFns } from "./ButtonVideoProblem.vue?vue&type=template&id=5c54e6b6&scoped=true&"
import script from "./ButtonVideoProblem.vue?vue&type=script&lang=js&"
export * from "./ButtonVideoProblem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonVideoProblem.vue?vue&type=style&index=0&id=5c54e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54e6b6",
  null
  
)

export default component.exports